import { combineReducers } from "redux";
import appLibrary from "./appLibrary";
import platformInfo from "./platformInfo";
import activeEditor from "./activeEditor";
import activeApp from "./activeApp";
import business from "./business";
import deals from "./deals";
import store from "./store";
import storeSettings from "./storeSettings";
import webStore from "./webStore";
import cart from "./cart";
import rewards from "./rewards";
import isLoading from "./isLoading";
import error from "./error";
import croppingRatio from "./croppingRatio";
import cards from "./cards";
import coupons from "./coupons";
import invoices from "./invoices";
import userApplicationsPermissions from "./userApplicationsPermissions";

const appData = combineReducers({
  appLibrary,
  platformInfo,
  activeEditor,
  deals,
  coupons,
  invoices,
  store,
  storeSettings,
  webStore,
  activeApp,
  business,
  rewards,
  isLoading,
  error,
  cards,
  cart,
  userApplicationsPermissions,
  croppingRatio,
});

export default appData;
